var r = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
function a(x) {
  return x.match(r) || [];
}
export {
  a as default
};
